import { jsx as _jsx } from "react/jsx-runtime";
export const CheckIcon = ({ color })=>/*#__PURE__*/ _jsx("svg", {
        width: "9",
        height: "8",
        viewBox: "0 0 9 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1 3.5L3.5 6.5L7.5 1",
            stroke: color || "#6161FF",
            "stroke-width": "1.25",
            strokeLinecap: "round"
        })
    });
